import {injectable} from "inversify";
import {Team} from "@/modules/team/entity";
import RandomTransferDecider from "@/modules/ai/services/transferDecider/RandomTransferDecider";

@injectable()
export default class TeamLevelTransferDecider extends RandomTransferDecider {
  async getMinSkill(team: Team): Promise<number> {
    return .65 * team.level;
  }

  async getMaxSkill(team: Team): Promise<number> {
    return team.level === 100 ? 999 : team.level;
  }
}
